import { LocalAudioTrack, LocalVideoTrack } from 'livekit-client'

export interface SessionProps {
  roomName: string
  identity: string
  audioTrack?: LocalAudioTrack
  videoTrack?: LocalVideoTrack
  region?: string
  turnServer?: RTCIceServer
  forceRelay?: boolean
}

export interface TokenResult {
  identity: string
  accessToken: string
}

export interface BgEffect {
  type: string
  options: BgEffectOptions
}

export interface BgEffectOptions {
  id?: string
  blurRadius?: number
  imagePath?: string
  name?: string
}

export const parsBrandingDataDefault = {
  primary_color: '#3396fa',
  text_primary_color: '#ffffff',
  border_radius: '8',
}

export type WidgetState = {
  showChat: boolean
  unreadMessages: number
  showParticipants: boolean
  activeParticipants: number
  waitingParticipants: number
}

export const WIDGET_DEFAULT_STATE: WidgetState = {
  showChat: false,
  unreadMessages: 0,
  showParticipants: false,
  activeParticipants: 0,
  waitingParticipants: 0,
}
